module.exports = __webpack_public_path__ + "img/jawg-dark.c412b68f.jpg";